import { render, staticRenderFns } from "./PlotMakerPage.vue?vue&type=template&id=315edc23&scoped=true"
import script from "./PlotMakerPage.vue?vue&type=script&lang=ts"
export * from "./PlotMakerPage.vue?vue&type=script&lang=ts"
import style0 from "./PlotMakerPage.vue?vue&type=style&index=0&id=315edc23&prod&lang=scss"
import style1 from "./PlotMakerPage.vue?vue&type=style&index=1&id=315edc23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315edc23",
  null
  
)

export default component.exports